
jQuery(document).ready(function(){
  
  
  jQuery("#r-more").click(function(){
    jQuery("#show-text").toggle();
    jQuery(".rr-more").toggle();
     jQuery(".rr-less").toggle();
  });

var thiswidth = 0;
  $(".tab_acadian").each(function(){  
	thiswidth = thiswidth +  $(this).outerWidth();
    $(this).attr("lOffset",thiswidth);
  });
$(".tab_acadian").click(function(){
  $(".tab_acadian").removeClass("thisactive");
  $(this).addClass("thisactive");
  var thisOffset = $(this).attr("lOffset");
  var currentWidth = $(this).outerWidth();
    var currentInnerWidth = $(this).width();
  thisOffset = thisOffset - currentWidth;
  $(".tab_acadian .gvs_line").css("transform","translatex("+thisOffset+"px)");
   $(".tab_acadian .gvs_line").css("width",currentInnerWidth+"px");
  

    var get = $(this).attr("data_ac_ID");
  	$(".description .text").removeClass("active");
  	$("#"+get).addClass("active");
});
});
jQuery(document).ready(function(){
  function gvsAccordionFaq(){
    jQuery(".collapsible-content__inner collapsible-row detail").removeClass("gvHeighLoaded");
      jQuery(".collapsible-content__inner collapsible-row detail").each(function(){
        var collapsibleHeight = $(this).find(".collapsible__content").height();
        console.log("height->"+collapsibleHeight);
        var thisHeight = $(this).height();
       // $(this).css("max-height",thisHeight); 
        collapsibleHeight = 20+collapsibleHeight;
       // $(this).find(".collapsible__content").css("max-height",collapsibleHeight);
        var thisE =  $(this);
        setTimeout(function(){
          thisE.addClass("gvHeighLoaded");
        },0);
          
        
      });
    
  }
  gvsAccordionFaq();
  $(window).resize(function(){
   gvsAccordionFaq();
});


  jQuery(".collapsible-content__inner collapsible-row detail summary").click(function(){
    $(this).closest("detail").toggleClass("open");
  });
});  